// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._2rko1l5z{border-radius:var(--ds-br)}._152tze3t{inset-block-start:var(--ds-space-0,0)}\n._1bah1h6o{justify-content:center}\n._1e0c1txw{display:flex}\n._4cvr1h6o{align-items:center}\n._4t3i7vkz{height:1pc}\n._kqswstnw{position:absolute}", ""]);
// Exports
module.exports = exports;
